import {
    PUSH_USER_DATA, RESET_USER_DATA,
    //PUSH_USER_DATA_ERROR
} from "../actions/types";

const INIT_STATE = {
    loggedUser : {}
}

const userReducer = function (state=INIT_STATE, action) {
    const {type, payload } = action;
    switch (type) {
        case PUSH_USER_DATA:
            return {
                ...state,
                loggedUser:payload
            }
        case RESET_USER_DATA:        
            return {
                ...state,
                loggedUser: {}
            } 
        default:
            return state;    
    }
};

export default userReducer;